import { ApiOwnerParty } from 'src/interfaces/interfaces.generated';

export const findCountryCode = (
  ownerParties: ApiOwnerParty[],
  activeOwnerParty: number
): string | undefined =>
  ownerParties.find((ownerParty) => ownerParty.id === activeOwnerParty)?.countryCode;
